import {
  FlatActionList,
  Stack,
  Text,
  Tooltip,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { ProductFormValues } from "../../types";
import { View, Spacings } from "react-native-ui-lib";
import { textButtonProps } from "../../constants";
import {
  CategoryIdToName,
  DepartmentIdToName,
} from "../../../../../../components";
import { Badge } from "react-native-ui-lib/src/components/badge";
import { useTranslation } from "../../../../../../utilities/i18n";
import { LllmQuickWinButton } from "../../../../../../components/LlmQuickWinButton";
import { useLlmQuickWinsProvider } from "../../../../../../utilities/llm-quick-wins";

export interface CategorizationFieldsetProps {
  onSelectDepartmentPress?: () => void;
  onSelectCategoryPress?: () => void;
  onManageTagsPress?: () => void;
  onTagsLlmQuickWinButtonPress?: () => void;
}

export const CategorizationFieldset = ({
  onSelectDepartmentPress,
  onSelectCategoryPress,
  onManageTagsPress,
  onTagsLlmQuickWinButtonPress,
}: CategorizationFieldsetProps) => {
  const { watch } = useFormContext<ProductFormValues>();
  const { t } = useTranslation("product");
  const watchedDepartmentId = watch("departmentId");
  const watchedCategoryId = watch("categoryId");
  const watchedTags = watch("tags");
  const { strategyEnabled } = useLlmQuickWinsProvider();

  const nameValue = watch("name");
  const descriptionValue = watch("description");

  const watchedGlobalDisable = watch("globalDisable");

  const aiDisabled =
    nameValue.length === 0 ||
    descriptionValue.length === 0 ||
    descriptionValue === "<br>";

  const textProps = {
    ...textButtonProps,
    ...(watchedGlobalDisable ? { color: "subdued" } : {}),
  };

  return (
    <View>
      <Stack vertical>
        <FlatActionList
          items={[
            {
              key: "departmentId",
              title: t("form.department.label"),
              subTitle: t("form.department.description"),
              disabled: watchedGlobalDisable,
              onPress: onSelectDepartmentPress,
              componentRight: () =>
                watchedDepartmentId ? (
                  <DepartmentIdToName
                    departmentId={watchedDepartmentId}
                    {...textProps}
                  />
                ) : (
                  <Text {...textProps}>{t("form.department.placeholder")}</Text>
                ),
            },

            {
              key: "categoryId",
              title: t("form.category.label"),
              subTitle: t("form.category.label"),
              onPress: onSelectCategoryPress,
              disabled: !watchedDepartmentId || watchedGlobalDisable,
              componentRight: () =>
                watchedCategoryId ? (
                  <CategoryIdToName
                    categoryId={watchedCategoryId}
                    {...textProps}
                  />
                ) : (
                  <Text
                    {...textProps}
                    {...(!watchedDepartmentId
                      ? {
                          color: "subdued",
                        }
                      : {})}
                  >
                    {t("form.category.placeholder")}
                  </Text>
                ),
            },
            {
              key: "tags",
              title: t("form.tags.label"),
              subTitle: t("form.tags.description"),
              disabled: watchedGlobalDisable,

              onPress: onManageTagsPress,
              titleContent({ title, subTitle }) {
                return (
                  <View>
                    <View row centerV>
                      {title}
                      {onTagsLlmQuickWinButtonPress &&
                      strategyEnabled("product_tags_quick_win") ? (
                        <View style={{ marginLeft: 8 }}>
                          <Tooltip text="Generate Tags with AI">
                            <LllmQuickWinButton
                              onPress={onTagsLlmQuickWinButtonPress}
                              disabled={aiDisabled}
                            />
                          </Tooltip>
                        </View>
                      ) : null}
                    </View>
                    {subTitle}
                    <View
                      style={{
                        marginTop: Spacings.s4,
                      }}
                    >
                      <Stack spacing={Spacings.s2}>
                        {watchedTags.map((tag) => (
                          <Badge
                            backgroundColor="rgb(216, 217, 219)"
                            labelStyle={{
                              color: "rgb(0, 0, 0)",
                            }}
                            key={tag}
                            label={tag}
                          />
                        ))}
                      </Stack>
                    </View>
                  </View>
                );
              },
              componentRight: () => (
                <Text {...textProps}>
                  {t("form.tags.placeholder", {
                    count: watchedTags.length,
                  })}
                </Text>
              ),
            },
          ]}
        />
      </Stack>
    </View>
  );
};
